import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div className="w-full flex flex-col items-center justify-center min-h-screen bg-white px-4">
      <h1 className="text-6xl font-bold text-dark-red mb-4">404</h1>
      <p className="text-xl text-gray-700 mb-8">페이지를 찾을 수 없습니다.</p>
      <Link to="/" className="text-blue-600 underline">
        홈으로 돌아가기
      </Link>
    </div>
  );
}
